<template>
  <v-container fill-height v-if="localLoading">
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="text-h5 mt-4">Cargando información...</div>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="preaspirante">
    <v-row>
      <v-col cols="12">
        <v-btn @click="$router.go(-1)" text class="back-button">
          <v-icon>mdi-arrow-left</v-icon>
          Volver al catálogo
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="5">
        <v-card class="modern-card">
          <v-card-title class="font-weight-bold justify-center card-title">Captura de voz</v-card-title>
          <v-card-text>
            <v-form v-model="capturaVozForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(preaspirante)"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Aspirante"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="fecha"
                      v-mask="'##/##/####'"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      :rules="dateRules"
                      hint="Formato de fecha: DD/MM/YYYY"
                    >
                      <template v-slot:label>Fecha de captura <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="file"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      :rules="nameRules"
                      prepend-icon="mdi-microphone"
                      accept="audio/*"
                      @change="onFileSelected"
                    >
                      <template v-slot:label>Adjuntar archivo de voz <span class="red--text">*</span> </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" v-if="audioUrl">
                    <audio-player-card :src="audioUrl" :filename="file && file.name" />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="observaciones"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Observaciones"
                      no-resize
                      rows="4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn
              class="action-button px-8"
              :disabled="!capturaVozForm || loading"
              :loading="loading"
              v-on:click="triggerSaveBiometrico()"
              >Registrar</v-btn
            >
          </v-card-actions>
        </v-card>

        <!-- Listado de capturas registradas -->
        <v-card class="modern-card mt-6" v-if="biometricosVoz.length > 0">
          <v-card-title class="font-weight-bold card-title">
            <v-icon color="secondary" class="mr-2">mdi-microphone</v-icon>
            Capturas registradas
          </v-card-title>
          <v-card-text>
            <v-list color="transparent">
              <v-list-item v-for="b in biometricosVoz" :key="b.id" class="biometrico-item">
                <v-list-item-icon>
                  <v-icon color="secondary">mdi-waveform</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">{{ b.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{ b.fechaRealizacion }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small :color="b.URL ? 'success' : 'warning'" outlined>
                    {{ b.URL ? 'Archivo disponible' : 'Sin archivo' }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import AudioPlayerCard from '@/components/expediente/AudioPlayerCard.vue'

export default {
  components: { AudioPlayerCard },
  props: {
    id: {
      type: Number,
    },
  },

  beforeDestroy() {
    if (this.audioUrl) URL.revokeObjectURL(this.audioUrl)
  },

  async mounted() {
    this.localLoading = true
    this.SET_PREASPIRANTE_PARA_VALIDACION(this.id)

    if (!this.preaspirante) {
      this.isPersonal = true
      try {
        await this.fetchPersonalById(this.id)
        if (this.personalSingle) {
          this.SET_PREASPIRANTE_PARA_VALIDACION_DIRECT(this.personalSingle)
        } else {
          this.SET_SNACKBAR_MESSAGE('No se pudo encontrar la información del personal.')
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al obtener la información del personal.')
      }
    }

    if (this.id) {
      await this.fetchBiometricosPersonal(this.id)
    }

    this.localLoading = false
  },

  data() {
    return {
      loading: false,
      localLoading: false,
      capturaVozForm: false,
      menu: false,
      isPersonal: false,

      observaciones: '',
      fecha: null,
      file: null,
      nombre: null,

      audioUrl: null,

      nameRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => !v || v.type.startsWith('audio/') || 'Solo se permiten archivos de audio (mp3, wav, ogg, m4a, etc.)',
      ],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirante: 'getPreaspiranteParaValidacion',
    }),
    ...mapGetters('personal', {
      personalSingle: 'getPersonalSingle',
    }),
    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    biometricosVoz() {
      return this.biometricosPersonal.filter((b) => b.TipoBiometrico && b.TipoBiometrico.id === 2)
    },
  },

  methods: {
    ...mapActions('biometrico', ['saveBiometricoPersonal', 'fetchBiometricosPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('preaspirante', ['SET_PREASPIRANTE_PARA_VALIDACION', 'SET_PREASPIRANTE_PARA_VALIDACION_DIRECT']),

    triggerSaveBiometrico: async function () {
      this.loading = true

      try {
        await this.saveBiometricoPersonal({
          nombre: this.file.name,
          fk_idPersonal: this.id,
          fk_idTipoBiometrico: 2,
          observaciones: this.observaciones,
          fechaRealizacion: this.fecha,
          file: this.file,
        })

        if (this.isPersonal) {
          this.$router.push({ name: 'personalPersonal' })
        } else {
          await this.fetchPreaspirantes()
          this.$router.push({ name: 'Preaspirantes' })
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al guardar el registro biométrico. Verifica el archivo e intenta de nuevo.')
      } finally {
        this.loading = false
      }
    },

    onFileSelected(file) {
      if (this.audioUrl) URL.revokeObjectURL(this.audioUrl)
      this.audioUrl = file ? URL.createObjectURL(file) : null
    },
  },
}
</script>

<style scoped>
.back-button {
  color: var(--v-secondary-base) !important;
  font-weight: 600;
}

.back-button:hover {
  background-color: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

.modern-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.card-title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #e0e0e0 !important;
}

::v-deep .modern-input {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

::v-deep .modern-input.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-file-input > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .modern-input.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-file-input:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modern-input.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-input--is-focused.v-file-input > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .modern-input .v-text-field__slot input,
::v-deep .modern-input .v-file-input__text {
  color: #e0e0e0 !important;
}

::v-deep .modern-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .modern-input.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-input .v-text-field__details {
  padding-left: 16px;
}

::v-deep .modern-input .v-icon {
  color: var(--v-secondary-base) !important;
}

.action-button {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-darken1) 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

.action-button:hover {
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.4);
  transform: translateY(-2px);
}

.action-button:disabled {
  background: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.3) !important;
  box-shadow: none !important;
}

.biometrico-item {
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.1);
}

.biometrico-item:last-child {
  border-bottom: none;
}

::v-deep .biometrico-item .v-list-item__title {
  color: #e0e0e0 !important;
}

::v-deep .biometrico-item .v-list-item__subtitle {
  color: rgba(224, 224, 224, 0.55) !important;
}
</style>
